(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-key-benefits"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gm-kb-slider')) {
  customElements.define('gm-kb-slider', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.gm-kb__grid');
      this.dotsWrap = this.querySelector('.gm-kb__dots');
      if (!this.grid || !this.dotsWrap) return;
      this.items = [...this.grid.children];
      this.dotsWrap.innerHTML = '';
      if (this.items.length < 2) return;
      this.items.forEach((item, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', () => {
          this.grid.scrollTo({ left: item.offsetLeft - (this.grid.clientWidth - item.clientWidth) / 2, behavior: 'smooth' });
        });
        this.dotsWrap.appendChild(dot);
      });
      this.dots = [...this.dotsWrap.children];
      this.onScroll = () => requestAnimationFrame(() => this.update());
      this.grid.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }
    disconnectedCallback() {
      if (this.grid && this.onScroll) this.grid.removeEventListener('scroll', this.onScroll);
    }
    update() {
      const center = this.grid.scrollLeft + this.grid.clientWidth / 2;
      let active = 0, min = Infinity;
      this.items.forEach((it, i) => {
        const d = Math.abs(it.offsetLeft + it.clientWidth / 2 - center);
        if (d < min) { min = d; active = i; }
      });
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === active));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-ritual"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gm-rt-slider')) {
  customElements.define('gm-rt-slider', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.gm-rt__grid');
      this.dotsWrap = this.querySelector('.gm-rt__dots');
      if (!this.grid || !this.dotsWrap) return;
      this.items = [...this.grid.children];
      this.dotsWrap.innerHTML = '';
      if (this.items.length < 2) return;
      this.items.forEach(() => this.dotsWrap.appendChild(document.createElement('span')));
      this.dots = [...this.dotsWrap.children];
      this.onScroll = () => requestAnimationFrame(() => this.update());
      this.grid.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }
    disconnectedCallback() {
      if (this.grid && this.onScroll) this.grid.removeEventListener('scroll', this.onScroll);
    }
    update() {
      const center = this.grid.scrollLeft + this.grid.clientWidth / 2;
      let active = 0, min = Infinity;
      this.items.forEach((it, i) => {
        const d = Math.abs(it.offsetLeft + it.clientWidth / 2 - center);
        if (d < min) { min = d; active = i; }
      });
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === active));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
